import { Observable, Subscriber, concat } from "rxjs";
import { retryWhen, share, takeUntil, finalize, scan, throttleTime, map } from "rxjs/operators";
import { ADCObserverModel, ProcessType, ADCDataWithAWRC } from "../../types";
import { getADCInitialData } from "../ALCInitialDataServices/ALCInitialDataServices";
import { errorHandler, setPubsubStream } from "../apiHelper";
import { getFactoryChangeObservable } from '../../Auth';
import { withLogger } from "../LogerServices";

const ADCType = ProcessType.ADC;
export const parseADCBreakdownData = (data: ADCDataWithAWRC) => {
    const parseStringToBoolean = (value: string) => value === 'true' ? true : false;
    const { IsBreakdown } = data;

    return {
        ...data,
        ...(IsBreakdown) && { IsBreakdown: parseStringToBoolean(IsBreakdown as string) },
    }
};

const ADCObserver: ADCObserverModel = {
    adcObservable: null as Observable<ADCDataWithAWRC>,
}

const setADCStream = () => new Observable<ADCDataWithAWRC>((observer: Subscriber<ADCDataWithAWRC>) => {
    const close = setPubsubStream(observer, ADCType);
    return close;
}).pipe(
    retryWhen(errors => errorHandler(errors)),
    takeUntil(getFactoryChangeObservable()),
    share()
);

const ARCDataObservable = () => {
    ADCObserver.adcObservable = concat(
        withLogger(getADCInitialData(), ADCType, {isInitial: true}),
        withLogger(setADCStream(), ADCType)
    ).pipe(
        scan((acc, val) => Object.assign({}, acc, val), {}),
        throttleTime(1000),
        map(parseADCBreakdownData),
        finalize(() => ADCObserver.adcObservable = null),
    )
    return ADCObserver.adcObservable
}

export const getARCDataObservable = (): Observable<ADCDataWithAWRC> => ADCObserver.adcObservable ? ADCObserver.adcObservable : ARCDataObservable();